import { Injectable } from '@angular/core'
import * as XLSX from 'xlsx'

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
const EXCEL_EXTENSION = '.xlsx'

@Injectable()
export class ExcelService {
    constructor() { }
    sheetname: string
    public exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json)
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] }

        XLSX.writeFile(workbook, excelFileName + EXCEL_EXTENSION, { bookType: 'xlsx', type: 'buffer' })
    }
    public exportAsExcelFileIpad(json: any[], excelFileName: string): void {
        let date = new Date();
        this.sheetname = 'iPadEnrollmentHistory' + "-" + date.getFullYear() + "_" + date.getMonth()
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json)
        const workbook: XLSX.WorkBook = { Sheets: { 'iPadEnrollmentHistory': worksheet }, SheetNames: ['iPadEnrollmentHistory'] }
        XLSX.writeFile(workbook, excelFileName + EXCEL_EXTENSION, { bookType: 'xlsx', type: 'buffer' })
    }
}